// source: billing.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.cloud.BillingAddress', null, global);
goog.exportSymbol('proto.cloud.BillingCharge', null, global);
goog.exportSymbol('proto.cloud.BillingDetails', null, global);
goog.exportSymbol('proto.cloud.BillingInvoice', null, global);
goog.exportSymbol('proto.cloud.BillingInvoice.Status', null, global);
goog.exportSymbol('proto.cloud.BillingSubscription', null, global);
goog.exportSymbol('proto.cloud.BillingSubscription.Item', null, global);
goog.exportSymbol('proto.cloud.BillingSubscription.Status', null, global);
goog.exportSymbol('proto.cloud.BillingSubscriptionSchedule', null, global);
goog.exportSymbol('proto.cloud.BillingSubscriptionSchedule.Status', null, global);
goog.exportSymbol('proto.cloud.BillingSubscriptionSchedulePhase', null, global);
goog.exportSymbol('proto.cloud.BillingSubscriptionSchedulePhase.Item', null, global);
goog.exportSymbol('proto.cloud.Coupon', null, global);
goog.exportSymbol('proto.cloud.PaymentMethod', null, global);
goog.exportSymbol('proto.cloud.Price', null, global);
goog.exportSymbol('proto.cloud.Price.Type', null, global);
goog.exportSymbol('proto.cloud.Product', null, global);
goog.exportSymbol('proto.cloud.Recurring', null, global);
goog.exportSymbol('proto.cloud.Recurring.BillInterval', null, global);
goog.exportSymbol('proto.cloud.Recurring.UsageType', null, global);
goog.exportSymbol('proto.cloud.RedactedCard', null, global);
goog.exportSymbol('proto.cloud.SubscriptionItem', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.SubscriptionItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.SubscriptionItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.SubscriptionItem.displayName = 'proto.cloud.SubscriptionItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.BillingInvoice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.BillingInvoice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.BillingInvoice.displayName = 'proto.cloud.BillingInvoice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.BillingCharge = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.BillingCharge, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.BillingCharge.displayName = 'proto.cloud.BillingCharge';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.BillingSubscriptionSchedulePhase = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.BillingSubscriptionSchedulePhase.repeatedFields_, null);
};
goog.inherits(proto.cloud.BillingSubscriptionSchedulePhase, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.BillingSubscriptionSchedulePhase.displayName = 'proto.cloud.BillingSubscriptionSchedulePhase';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.BillingSubscriptionSchedulePhase.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.BillingSubscriptionSchedulePhase.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.BillingSubscriptionSchedulePhase.Item.displayName = 'proto.cloud.BillingSubscriptionSchedulePhase.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.BillingSubscriptionSchedule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.BillingSubscriptionSchedule.repeatedFields_, null);
};
goog.inherits(proto.cloud.BillingSubscriptionSchedule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.BillingSubscriptionSchedule.displayName = 'proto.cloud.BillingSubscriptionSchedule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.BillingSubscription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.BillingSubscription.repeatedFields_, null);
};
goog.inherits(proto.cloud.BillingSubscription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.BillingSubscription.displayName = 'proto.cloud.BillingSubscription';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.BillingSubscription.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.BillingSubscription.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.BillingSubscription.Item.displayName = 'proto.cloud.BillingSubscription.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.Coupon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.Coupon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.Coupon.displayName = 'proto.cloud.Coupon';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.PaymentMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.PaymentMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.PaymentMethod.displayName = 'proto.cloud.PaymentMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.RedactedCard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.RedactedCard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.RedactedCard.displayName = 'proto.cloud.RedactedCard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.BillingDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.BillingDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.BillingDetails.displayName = 'proto.cloud.BillingDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.BillingAddress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.BillingAddress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.BillingAddress.displayName = 'proto.cloud.BillingAddress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.Product = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.Product, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.Product.displayName = 'proto.cloud.Product';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.Price = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.Price, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.Price.displayName = 'proto.cloud.Price';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.Recurring = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.Recurring, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.Recurring.displayName = 'proto.cloud.Recurring';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.SubscriptionItem.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.SubscriptionItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.SubscriptionItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.SubscriptionItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    priceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.SubscriptionItem}
 */
proto.cloud.SubscriptionItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.SubscriptionItem;
  return proto.cloud.SubscriptionItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.SubscriptionItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.SubscriptionItem}
 */
proto.cloud.SubscriptionItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.SubscriptionItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.SubscriptionItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.SubscriptionItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.SubscriptionItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string price_id = 1;
 * @return {string}
 */
proto.cloud.SubscriptionItem.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SubscriptionItem} returns this
 */
proto.cloud.SubscriptionItem.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 quantity = 2;
 * @return {number}
 */
proto.cloud.SubscriptionItem.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.SubscriptionItem} returns this
 */
proto.cloud.SubscriptionItem.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.BillingInvoice.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.BillingInvoice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.BillingInvoice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingInvoice.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    latestCharge: (f = msg.getLatestCharge()) && proto.cloud.BillingCharge.toObject(includeInstance, f),
    customerId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    hostedInvoiceUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    invoicePdf: jspb.Message.getFieldWithDefault(msg, 5, ""),
    periodStart: jspb.Message.getFieldWithDefault(msg, 6, ""),
    periodEnd: jspb.Message.getFieldWithDefault(msg, 7, ""),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0),
    total: jspb.Message.getFieldWithDefault(msg, 9, 0),
    subTotal: jspb.Message.getFieldWithDefault(msg, 10, 0),
    tax: jspb.Message.getFieldWithDefault(msg, 11, 0),
    paid: jspb.Message.getBooleanFieldWithDefault(msg, 12, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.BillingInvoice}
 */
proto.cloud.BillingInvoice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.BillingInvoice;
  return proto.cloud.BillingInvoice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.BillingInvoice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.BillingInvoice}
 */
proto.cloud.BillingInvoice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.cloud.BillingCharge;
      reader.readMessage(value,proto.cloud.BillingCharge.deserializeBinaryFromReader);
      msg.setLatestCharge(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHostedInvoiceUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoicePdf(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeriodStart(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeriodEnd(value);
      break;
    case 8:
      var value = /** @type {!proto.cloud.BillingInvoice.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubTotal(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTax(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.BillingInvoice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.BillingInvoice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.BillingInvoice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingInvoice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLatestCharge();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.cloud.BillingCharge.serializeBinaryToWriter
    );
  }
  f = message.getCustomerId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHostedInvoiceUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInvoicePdf();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPeriodStart();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPeriodEnd();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getSubTotal();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getTax();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getPaid();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.cloud.BillingInvoice.Status = {
  STATUS_INVOICE_UNKNOWN: 0,
  STATUS_DRAFT: 1,
  STATUS_OPEN: 2,
  STATUS_PAID: 3,
  STATUS_UNCOLLECTIBLE: 4,
  STATUS_VOID: 5
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.cloud.BillingInvoice.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingInvoice} returns this
 */
proto.cloud.BillingInvoice.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional BillingCharge latest_charge = 2;
 * @return {?proto.cloud.BillingCharge}
 */
proto.cloud.BillingInvoice.prototype.getLatestCharge = function() {
  return /** @type{?proto.cloud.BillingCharge} */ (
    jspb.Message.getWrapperField(this, proto.cloud.BillingCharge, 2));
};


/**
 * @param {?proto.cloud.BillingCharge|undefined} value
 * @return {!proto.cloud.BillingInvoice} returns this
*/
proto.cloud.BillingInvoice.prototype.setLatestCharge = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.BillingInvoice} returns this
 */
proto.cloud.BillingInvoice.prototype.clearLatestCharge = function() {
  return this.setLatestCharge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.BillingInvoice.prototype.hasLatestCharge = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string customer_id = 3;
 * @return {string}
 */
proto.cloud.BillingInvoice.prototype.getCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingInvoice} returns this
 */
proto.cloud.BillingInvoice.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string hosted_invoice_url = 4;
 * @return {string}
 */
proto.cloud.BillingInvoice.prototype.getHostedInvoiceUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingInvoice} returns this
 */
proto.cloud.BillingInvoice.prototype.setHostedInvoiceUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string invoice_pdf = 5;
 * @return {string}
 */
proto.cloud.BillingInvoice.prototype.getInvoicePdf = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingInvoice} returns this
 */
proto.cloud.BillingInvoice.prototype.setInvoicePdf = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string period_start = 6;
 * @return {string}
 */
proto.cloud.BillingInvoice.prototype.getPeriodStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingInvoice} returns this
 */
proto.cloud.BillingInvoice.prototype.setPeriodStart = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string period_end = 7;
 * @return {string}
 */
proto.cloud.BillingInvoice.prototype.getPeriodEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingInvoice} returns this
 */
proto.cloud.BillingInvoice.prototype.setPeriodEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional Status status = 8;
 * @return {!proto.cloud.BillingInvoice.Status}
 */
proto.cloud.BillingInvoice.prototype.getStatus = function() {
  return /** @type {!proto.cloud.BillingInvoice.Status} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.cloud.BillingInvoice.Status} value
 * @return {!proto.cloud.BillingInvoice} returns this
 */
proto.cloud.BillingInvoice.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional int64 total = 9;
 * @return {number}
 */
proto.cloud.BillingInvoice.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.BillingInvoice} returns this
 */
proto.cloud.BillingInvoice.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 sub_total = 10;
 * @return {number}
 */
proto.cloud.BillingInvoice.prototype.getSubTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.BillingInvoice} returns this
 */
proto.cloud.BillingInvoice.prototype.setSubTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 tax = 11;
 * @return {number}
 */
proto.cloud.BillingInvoice.prototype.getTax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.BillingInvoice} returns this
 */
proto.cloud.BillingInvoice.prototype.setTax = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional bool paid = 12;
 * @return {boolean}
 */
proto.cloud.BillingInvoice.prototype.getPaid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.BillingInvoice} returns this
 */
proto.cloud.BillingInvoice.prototype.setPaid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.BillingCharge.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.BillingCharge.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.BillingCharge} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingCharge.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    amount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    customerId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    invoiceId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    emailReceiptSent: jspb.Message.getFieldWithDefault(msg, 5, ""),
    refunded: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    receiptUrl: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.BillingCharge}
 */
proto.cloud.BillingCharge.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.BillingCharge;
  return proto.cloud.BillingCharge.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.BillingCharge} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.BillingCharge}
 */
proto.cloud.BillingCharge.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailReceiptSent(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRefunded(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceiptUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.BillingCharge.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.BillingCharge.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.BillingCharge} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingCharge.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getCustomerId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getInvoiceId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEmailReceiptSent();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRefunded();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getReceiptUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.cloud.BillingCharge.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingCharge} returns this
 */
proto.cloud.BillingCharge.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 amount = 2;
 * @return {number}
 */
proto.cloud.BillingCharge.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.BillingCharge} returns this
 */
proto.cloud.BillingCharge.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string customer_id = 3;
 * @return {string}
 */
proto.cloud.BillingCharge.prototype.getCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingCharge} returns this
 */
proto.cloud.BillingCharge.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string invoice_id = 4;
 * @return {string}
 */
proto.cloud.BillingCharge.prototype.getInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingCharge} returns this
 */
proto.cloud.BillingCharge.prototype.setInvoiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string email_receipt_sent = 5;
 * @return {string}
 */
proto.cloud.BillingCharge.prototype.getEmailReceiptSent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingCharge} returns this
 */
proto.cloud.BillingCharge.prototype.setEmailReceiptSent = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool refunded = 6;
 * @return {boolean}
 */
proto.cloud.BillingCharge.prototype.getRefunded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.BillingCharge} returns this
 */
proto.cloud.BillingCharge.prototype.setRefunded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string receipt_url = 7;
 * @return {string}
 */
proto.cloud.BillingCharge.prototype.getReceiptUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingCharge} returns this
 */
proto.cloud.BillingCharge.prototype.setReceiptUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.BillingSubscriptionSchedulePhase.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.BillingSubscriptionSchedulePhase.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.BillingSubscriptionSchedulePhase.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.BillingSubscriptionSchedulePhase} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingSubscriptionSchedulePhase.toObject = function(includeInstance, msg) {
  var f, obj = {
    trialEnd: jspb.Message.getFieldWithDefault(msg, 1, ""),
    phaseStartDate: jspb.Message.getFieldWithDefault(msg, 2, ""),
    phaseEndDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    coupon: jspb.Message.getFieldWithDefault(msg, 6, ""),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.cloud.BillingSubscriptionSchedulePhase.Item.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.BillingSubscriptionSchedulePhase}
 */
proto.cloud.BillingSubscriptionSchedulePhase.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.BillingSubscriptionSchedulePhase;
  return proto.cloud.BillingSubscriptionSchedulePhase.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.BillingSubscriptionSchedulePhase} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.BillingSubscriptionSchedulePhase}
 */
proto.cloud.BillingSubscriptionSchedulePhase.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrialEnd(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhaseStartDate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhaseEndDate(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoupon(value);
      break;
    case 7:
      var value = new proto.cloud.BillingSubscriptionSchedulePhase.Item;
      reader.readMessage(value,proto.cloud.BillingSubscriptionSchedulePhase.Item.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.BillingSubscriptionSchedulePhase.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.BillingSubscriptionSchedulePhase.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.BillingSubscriptionSchedulePhase} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingSubscriptionSchedulePhase.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrialEnd();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPhaseStartDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhaseEndDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCoupon();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.cloud.BillingSubscriptionSchedulePhase.Item.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.BillingSubscriptionSchedulePhase.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.BillingSubscriptionSchedulePhase.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.BillingSubscriptionSchedulePhase.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingSubscriptionSchedulePhase.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    priceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.BillingSubscriptionSchedulePhase.Item}
 */
proto.cloud.BillingSubscriptionSchedulePhase.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.BillingSubscriptionSchedulePhase.Item;
  return proto.cloud.BillingSubscriptionSchedulePhase.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.BillingSubscriptionSchedulePhase.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.BillingSubscriptionSchedulePhase.Item}
 */
proto.cloud.BillingSubscriptionSchedulePhase.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.BillingSubscriptionSchedulePhase.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.BillingSubscriptionSchedulePhase.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.BillingSubscriptionSchedulePhase.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingSubscriptionSchedulePhase.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string price_id = 2;
 * @return {string}
 */
proto.cloud.BillingSubscriptionSchedulePhase.Item.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingSubscriptionSchedulePhase.Item} returns this
 */
proto.cloud.BillingSubscriptionSchedulePhase.Item.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 quantity = 3;
 * @return {number}
 */
proto.cloud.BillingSubscriptionSchedulePhase.Item.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.BillingSubscriptionSchedulePhase.Item} returns this
 */
proto.cloud.BillingSubscriptionSchedulePhase.Item.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string trial_end = 1;
 * @return {string}
 */
proto.cloud.BillingSubscriptionSchedulePhase.prototype.getTrialEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingSubscriptionSchedulePhase} returns this
 */
proto.cloud.BillingSubscriptionSchedulePhase.prototype.setTrialEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string phase_start_date = 2;
 * @return {string}
 */
proto.cloud.BillingSubscriptionSchedulePhase.prototype.getPhaseStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingSubscriptionSchedulePhase} returns this
 */
proto.cloud.BillingSubscriptionSchedulePhase.prototype.setPhaseStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string phase_end_date = 3;
 * @return {string}
 */
proto.cloud.BillingSubscriptionSchedulePhase.prototype.getPhaseEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingSubscriptionSchedulePhase} returns this
 */
proto.cloud.BillingSubscriptionSchedulePhase.prototype.setPhaseEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string coupon = 6;
 * @return {string}
 */
proto.cloud.BillingSubscriptionSchedulePhase.prototype.getCoupon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingSubscriptionSchedulePhase} returns this
 */
proto.cloud.BillingSubscriptionSchedulePhase.prototype.setCoupon = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated Item items = 7;
 * @return {!Array<!proto.cloud.BillingSubscriptionSchedulePhase.Item>}
 */
proto.cloud.BillingSubscriptionSchedulePhase.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.cloud.BillingSubscriptionSchedulePhase.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.BillingSubscriptionSchedulePhase.Item, 7));
};


/**
 * @param {!Array<!proto.cloud.BillingSubscriptionSchedulePhase.Item>} value
 * @return {!proto.cloud.BillingSubscriptionSchedulePhase} returns this
*/
proto.cloud.BillingSubscriptionSchedulePhase.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.cloud.BillingSubscriptionSchedulePhase.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.BillingSubscriptionSchedulePhase.Item}
 */
proto.cloud.BillingSubscriptionSchedulePhase.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.cloud.BillingSubscriptionSchedulePhase.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.BillingSubscriptionSchedulePhase} returns this
 */
proto.cloud.BillingSubscriptionSchedulePhase.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.BillingSubscriptionSchedule.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.BillingSubscriptionSchedule.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.BillingSubscriptionSchedule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.BillingSubscriptionSchedule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingSubscriptionSchedule.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    phasesList: jspb.Message.toObjectList(msg.getPhasesList(),
    proto.cloud.BillingSubscriptionSchedulePhase.toObject, includeInstance),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.BillingSubscriptionSchedule}
 */
proto.cloud.BillingSubscriptionSchedule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.BillingSubscriptionSchedule;
  return proto.cloud.BillingSubscriptionSchedule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.BillingSubscriptionSchedule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.BillingSubscriptionSchedule}
 */
proto.cloud.BillingSubscriptionSchedule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.cloud.BillingSubscriptionSchedulePhase;
      reader.readMessage(value,proto.cloud.BillingSubscriptionSchedulePhase.deserializeBinaryFromReader);
      msg.addPhases(value);
      break;
    case 4:
      var value = /** @type {!proto.cloud.BillingSubscriptionSchedule.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.BillingSubscriptionSchedule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.BillingSubscriptionSchedule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.BillingSubscriptionSchedule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingSubscriptionSchedule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPhasesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.cloud.BillingSubscriptionSchedulePhase.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.cloud.BillingSubscriptionSchedule.Status = {
  STATUS_SCHEDULE_UNKNOWN: 0,
  STATUS_SCHEDULE_NOT_STARTED: 1,
  STATUS_SCHEDULE_ACTIVE: 2,
  STATUS_SCHEDULE_COMPLETED: 3,
  STATUS_SCHEDULE_RELEASED: 4,
  STATUS_SCHEDULE_CANCELED: 5,
  STATUS_SCHEDULE_TRIALING: 6
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.cloud.BillingSubscriptionSchedule.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingSubscriptionSchedule} returns this
 */
proto.cloud.BillingSubscriptionSchedule.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated BillingSubscriptionSchedulePhase phases = 2;
 * @return {!Array<!proto.cloud.BillingSubscriptionSchedulePhase>}
 */
proto.cloud.BillingSubscriptionSchedule.prototype.getPhasesList = function() {
  return /** @type{!Array<!proto.cloud.BillingSubscriptionSchedulePhase>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.BillingSubscriptionSchedulePhase, 2));
};


/**
 * @param {!Array<!proto.cloud.BillingSubscriptionSchedulePhase>} value
 * @return {!proto.cloud.BillingSubscriptionSchedule} returns this
*/
proto.cloud.BillingSubscriptionSchedule.prototype.setPhasesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.cloud.BillingSubscriptionSchedulePhase=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.BillingSubscriptionSchedulePhase}
 */
proto.cloud.BillingSubscriptionSchedule.prototype.addPhases = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.cloud.BillingSubscriptionSchedulePhase, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.BillingSubscriptionSchedule} returns this
 */
proto.cloud.BillingSubscriptionSchedule.prototype.clearPhasesList = function() {
  return this.setPhasesList([]);
};


/**
 * optional Status status = 4;
 * @return {!proto.cloud.BillingSubscriptionSchedule.Status}
 */
proto.cloud.BillingSubscriptionSchedule.prototype.getStatus = function() {
  return /** @type {!proto.cloud.BillingSubscriptionSchedule.Status} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.cloud.BillingSubscriptionSchedule.Status} value
 * @return {!proto.cloud.BillingSubscriptionSchedule} returns this
 */
proto.cloud.BillingSubscriptionSchedule.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.BillingSubscription.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.BillingSubscription.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.BillingSubscription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.BillingSubscription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingSubscription.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    cancelAtPeriodEnd: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    currentPeriodEnd: jspb.Message.getFieldWithDefault(msg, 3, ""),
    currentPeriodStart: jspb.Message.getFieldWithDefault(msg, 4, ""),
    customerId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    defaultPaymentId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.cloud.BillingSubscription.Item.toObject, includeInstance),
    latestInvoice: (f = msg.getLatestInvoice()) && proto.cloud.BillingInvoice.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 9, 0),
    schedule: (f = msg.getSchedule()) && proto.cloud.BillingSubscriptionSchedule.toObject(includeInstance, f),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.BillingSubscription}
 */
proto.cloud.BillingSubscription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.BillingSubscription;
  return proto.cloud.BillingSubscription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.BillingSubscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.BillingSubscription}
 */
proto.cloud.BillingSubscription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCancelAtPeriodEnd(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentPeriodEnd(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentPeriodStart(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultPaymentId(value);
      break;
    case 7:
      var value = new proto.cloud.BillingSubscription.Item;
      reader.readMessage(value,proto.cloud.BillingSubscription.Item.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 8:
      var value = new proto.cloud.BillingInvoice;
      reader.readMessage(value,proto.cloud.BillingInvoice.deserializeBinaryFromReader);
      msg.setLatestInvoice(value);
      break;
    case 9:
      var value = /** @type {!proto.cloud.BillingSubscription.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 10:
      var value = new proto.cloud.BillingSubscriptionSchedule;
      reader.readMessage(value,proto.cloud.BillingSubscriptionSchedule.deserializeBinaryFromReader);
      msg.setSchedule(value);
      break;
    case 11:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.BillingSubscription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.BillingSubscription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.BillingSubscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingSubscription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCancelAtPeriodEnd();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getCurrentPeriodEnd();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCurrentPeriodStart();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCustomerId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDefaultPaymentId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.cloud.BillingSubscription.Item.serializeBinaryToWriter
    );
  }
  f = message.getLatestInvoice();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.cloud.BillingInvoice.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getSchedule();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.cloud.BillingSubscriptionSchedule.serializeBinaryToWriter
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(11, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * @enum {number}
 */
proto.cloud.BillingSubscription.Status = {
  STATUS_UNKNOWN: 0,
  STATUS_ACTIVE: 1,
  STATUS_PAST_DUE: 2,
  STATUS_UNPAID: 3,
  STATUS_CANCELED: 4,
  STATUS_INCOMPLETE: 5,
  STATUS_INCOMPLETE_EXPIRED: 6,
  STATUS_TRIALING: 7
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.BillingSubscription.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.BillingSubscription.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.BillingSubscription.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingSubscription.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    priceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.BillingSubscription.Item}
 */
proto.cloud.BillingSubscription.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.BillingSubscription.Item;
  return proto.cloud.BillingSubscription.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.BillingSubscription.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.BillingSubscription.Item}
 */
proto.cloud.BillingSubscription.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.BillingSubscription.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.BillingSubscription.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.BillingSubscription.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingSubscription.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.cloud.BillingSubscription.Item.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingSubscription.Item} returns this
 */
proto.cloud.BillingSubscription.Item.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string price_id = 2;
 * @return {string}
 */
proto.cloud.BillingSubscription.Item.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingSubscription.Item} returns this
 */
proto.cloud.BillingSubscription.Item.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 quantity = 3;
 * @return {number}
 */
proto.cloud.BillingSubscription.Item.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.BillingSubscription.Item} returns this
 */
proto.cloud.BillingSubscription.Item.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.cloud.BillingSubscription.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingSubscription} returns this
 */
proto.cloud.BillingSubscription.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool cancel_at_period_end = 2;
 * @return {boolean}
 */
proto.cloud.BillingSubscription.prototype.getCancelAtPeriodEnd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.BillingSubscription} returns this
 */
proto.cloud.BillingSubscription.prototype.setCancelAtPeriodEnd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string current_period_end = 3;
 * @return {string}
 */
proto.cloud.BillingSubscription.prototype.getCurrentPeriodEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingSubscription} returns this
 */
proto.cloud.BillingSubscription.prototype.setCurrentPeriodEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string current_period_start = 4;
 * @return {string}
 */
proto.cloud.BillingSubscription.prototype.getCurrentPeriodStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingSubscription} returns this
 */
proto.cloud.BillingSubscription.prototype.setCurrentPeriodStart = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string customer_id = 5;
 * @return {string}
 */
proto.cloud.BillingSubscription.prototype.getCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingSubscription} returns this
 */
proto.cloud.BillingSubscription.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string default_payment_id = 6;
 * @return {string}
 */
proto.cloud.BillingSubscription.prototype.getDefaultPaymentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingSubscription} returns this
 */
proto.cloud.BillingSubscription.prototype.setDefaultPaymentId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated Item items = 7;
 * @return {!Array<!proto.cloud.BillingSubscription.Item>}
 */
proto.cloud.BillingSubscription.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.cloud.BillingSubscription.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.BillingSubscription.Item, 7));
};


/**
 * @param {!Array<!proto.cloud.BillingSubscription.Item>} value
 * @return {!proto.cloud.BillingSubscription} returns this
*/
proto.cloud.BillingSubscription.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.cloud.BillingSubscription.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.BillingSubscription.Item}
 */
proto.cloud.BillingSubscription.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.cloud.BillingSubscription.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.BillingSubscription} returns this
 */
proto.cloud.BillingSubscription.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional BillingInvoice latest_invoice = 8;
 * @return {?proto.cloud.BillingInvoice}
 */
proto.cloud.BillingSubscription.prototype.getLatestInvoice = function() {
  return /** @type{?proto.cloud.BillingInvoice} */ (
    jspb.Message.getWrapperField(this, proto.cloud.BillingInvoice, 8));
};


/**
 * @param {?proto.cloud.BillingInvoice|undefined} value
 * @return {!proto.cloud.BillingSubscription} returns this
*/
proto.cloud.BillingSubscription.prototype.setLatestInvoice = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.BillingSubscription} returns this
 */
proto.cloud.BillingSubscription.prototype.clearLatestInvoice = function() {
  return this.setLatestInvoice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.BillingSubscription.prototype.hasLatestInvoice = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Status status = 9;
 * @return {!proto.cloud.BillingSubscription.Status}
 */
proto.cloud.BillingSubscription.prototype.getStatus = function() {
  return /** @type {!proto.cloud.BillingSubscription.Status} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.cloud.BillingSubscription.Status} value
 * @return {!proto.cloud.BillingSubscription} returns this
 */
proto.cloud.BillingSubscription.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional BillingSubscriptionSchedule schedule = 10;
 * @return {?proto.cloud.BillingSubscriptionSchedule}
 */
proto.cloud.BillingSubscription.prototype.getSchedule = function() {
  return /** @type{?proto.cloud.BillingSubscriptionSchedule} */ (
    jspb.Message.getWrapperField(this, proto.cloud.BillingSubscriptionSchedule, 10));
};


/**
 * @param {?proto.cloud.BillingSubscriptionSchedule|undefined} value
 * @return {!proto.cloud.BillingSubscription} returns this
*/
proto.cloud.BillingSubscription.prototype.setSchedule = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.BillingSubscription} returns this
 */
proto.cloud.BillingSubscription.prototype.clearSchedule = function() {
  return this.setSchedule(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.BillingSubscription.prototype.hasSchedule = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * map<string, string> metadata = 11;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.cloud.BillingSubscription.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 11, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.cloud.BillingSubscription} returns this
 */
proto.cloud.BillingSubscription.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.Coupon.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.Coupon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.Coupon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Coupon.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    amountOff: jspb.Message.getFieldWithDefault(msg, 2, 0),
    duration: jspb.Message.getFieldWithDefault(msg, 3, ""),
    percentOff: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.Coupon}
 */
proto.cloud.Coupon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.Coupon;
  return proto.cloud.Coupon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.Coupon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.Coupon}
 */
proto.cloud.Coupon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountOff(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDuration(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPercentOff(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.Coupon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.Coupon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.Coupon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Coupon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmountOff();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDuration();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPercentOff();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.cloud.Coupon.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Coupon} returns this
 */
proto.cloud.Coupon.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 amount_off = 2;
 * @return {number}
 */
proto.cloud.Coupon.prototype.getAmountOff = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Coupon} returns this
 */
proto.cloud.Coupon.prototype.setAmountOff = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string duration = 3;
 * @return {string}
 */
proto.cloud.Coupon.prototype.getDuration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Coupon} returns this
 */
proto.cloud.Coupon.prototype.setDuration = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double percent_off = 4;
 * @return {number}
 */
proto.cloud.Coupon.prototype.getPercentOff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Coupon} returns this
 */
proto.cloud.Coupon.prototype.setPercentOff = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.PaymentMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.PaymentMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.PaymentMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.PaymentMethod.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    billingDetails: (f = msg.getBillingDetails()) && proto.cloud.BillingDetails.toObject(includeInstance, f),
    customerId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    paymentType: jspb.Message.getFieldWithDefault(msg, 4, ""),
    card: (f = msg.getCard()) && proto.cloud.RedactedCard.toObject(includeInstance, f),
    isDefault: jspb.Message.getBooleanFieldWithDefault(msg, 32, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.PaymentMethod}
 */
proto.cloud.PaymentMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.PaymentMethod;
  return proto.cloud.PaymentMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.PaymentMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.PaymentMethod}
 */
proto.cloud.PaymentMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.cloud.BillingDetails;
      reader.readMessage(value,proto.cloud.BillingDetails.deserializeBinaryFromReader);
      msg.setBillingDetails(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentType(value);
      break;
    case 5:
      var value = new proto.cloud.RedactedCard;
      reader.readMessage(value,proto.cloud.RedactedCard.deserializeBinaryFromReader);
      msg.setCard(value);
      break;
    case 32:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDefault(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.PaymentMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.PaymentMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.PaymentMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.PaymentMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBillingDetails();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.cloud.BillingDetails.serializeBinaryToWriter
    );
  }
  f = message.getCustomerId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPaymentType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCard();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.cloud.RedactedCard.serializeBinaryToWriter
    );
  }
  f = message.getIsDefault();
  if (f) {
    writer.writeBool(
      32,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.cloud.PaymentMethod.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.PaymentMethod} returns this
 */
proto.cloud.PaymentMethod.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional BillingDetails billing_details = 2;
 * @return {?proto.cloud.BillingDetails}
 */
proto.cloud.PaymentMethod.prototype.getBillingDetails = function() {
  return /** @type{?proto.cloud.BillingDetails} */ (
    jspb.Message.getWrapperField(this, proto.cloud.BillingDetails, 2));
};


/**
 * @param {?proto.cloud.BillingDetails|undefined} value
 * @return {!proto.cloud.PaymentMethod} returns this
*/
proto.cloud.PaymentMethod.prototype.setBillingDetails = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.PaymentMethod} returns this
 */
proto.cloud.PaymentMethod.prototype.clearBillingDetails = function() {
  return this.setBillingDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.PaymentMethod.prototype.hasBillingDetails = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string customer_id = 3;
 * @return {string}
 */
proto.cloud.PaymentMethod.prototype.getCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.PaymentMethod} returns this
 */
proto.cloud.PaymentMethod.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string payment_type = 4;
 * @return {string}
 */
proto.cloud.PaymentMethod.prototype.getPaymentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.PaymentMethod} returns this
 */
proto.cloud.PaymentMethod.prototype.setPaymentType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional RedactedCard card = 5;
 * @return {?proto.cloud.RedactedCard}
 */
proto.cloud.PaymentMethod.prototype.getCard = function() {
  return /** @type{?proto.cloud.RedactedCard} */ (
    jspb.Message.getWrapperField(this, proto.cloud.RedactedCard, 5));
};


/**
 * @param {?proto.cloud.RedactedCard|undefined} value
 * @return {!proto.cloud.PaymentMethod} returns this
*/
proto.cloud.PaymentMethod.prototype.setCard = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.PaymentMethod} returns this
 */
proto.cloud.PaymentMethod.prototype.clearCard = function() {
  return this.setCard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.PaymentMethod.prototype.hasCard = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool is_default = 32;
 * @return {boolean}
 */
proto.cloud.PaymentMethod.prototype.getIsDefault = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 32, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.PaymentMethod} returns this
 */
proto.cloud.PaymentMethod.prototype.setIsDefault = function(value) {
  return jspb.Message.setProto3BooleanField(this, 32, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.RedactedCard.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.RedactedCard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.RedactedCard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.RedactedCard.toObject = function(includeInstance, msg) {
  var f, obj = {
    brand: jspb.Message.getFieldWithDefault(msg, 1, ""),
    expMonth: jspb.Message.getFieldWithDefault(msg, 2, 0),
    expYear: jspb.Message.getFieldWithDefault(msg, 3, 0),
    fundingType: jspb.Message.getFieldWithDefault(msg, 4, ""),
    lastFour: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.RedactedCard}
 */
proto.cloud.RedactedCard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.RedactedCard;
  return proto.cloud.RedactedCard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.RedactedCard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.RedactedCard}
 */
proto.cloud.RedactedCard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpMonth(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpYear(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFundingType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastFour(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.RedactedCard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.RedactedCard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.RedactedCard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.RedactedCard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpMonth();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getExpYear();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getFundingType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLastFour();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string brand = 1;
 * @return {string}
 */
proto.cloud.RedactedCard.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.RedactedCard} returns this
 */
proto.cloud.RedactedCard.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 exp_month = 2;
 * @return {number}
 */
proto.cloud.RedactedCard.prototype.getExpMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.RedactedCard} returns this
 */
proto.cloud.RedactedCard.prototype.setExpMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 exp_year = 3;
 * @return {number}
 */
proto.cloud.RedactedCard.prototype.getExpYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.RedactedCard} returns this
 */
proto.cloud.RedactedCard.prototype.setExpYear = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string funding_type = 4;
 * @return {string}
 */
proto.cloud.RedactedCard.prototype.getFundingType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.RedactedCard} returns this
 */
proto.cloud.RedactedCard.prototype.setFundingType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string last_four = 5;
 * @return {string}
 */
proto.cloud.RedactedCard.prototype.getLastFour = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.RedactedCard} returns this
 */
proto.cloud.RedactedCard.prototype.setLastFour = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.BillingDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.BillingDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.BillingDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailAddress: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fullName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 3, ""),
    billingAddress: (f = msg.getBillingAddress()) && proto.cloud.BillingAddress.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.BillingDetails}
 */
proto.cloud.BillingDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.BillingDetails;
  return proto.cloud.BillingDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.BillingDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.BillingDetails}
 */
proto.cloud.BillingDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailAddress(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 4:
      var value = new proto.cloud.BillingAddress;
      reader.readMessage(value,proto.cloud.BillingAddress.deserializeBinaryFromReader);
      msg.setBillingAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.BillingDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.BillingDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.BillingDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailAddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFullName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBillingAddress();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.cloud.BillingAddress.serializeBinaryToWriter
    );
  }
};


/**
 * optional string email_address = 1;
 * @return {string}
 */
proto.cloud.BillingDetails.prototype.getEmailAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingDetails} returns this
 */
proto.cloud.BillingDetails.prototype.setEmailAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string full_name = 2;
 * @return {string}
 */
proto.cloud.BillingDetails.prototype.getFullName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingDetails} returns this
 */
proto.cloud.BillingDetails.prototype.setFullName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string phone = 3;
 * @return {string}
 */
proto.cloud.BillingDetails.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingDetails} returns this
 */
proto.cloud.BillingDetails.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional BillingAddress billing_address = 4;
 * @return {?proto.cloud.BillingAddress}
 */
proto.cloud.BillingDetails.prototype.getBillingAddress = function() {
  return /** @type{?proto.cloud.BillingAddress} */ (
    jspb.Message.getWrapperField(this, proto.cloud.BillingAddress, 4));
};


/**
 * @param {?proto.cloud.BillingAddress|undefined} value
 * @return {!proto.cloud.BillingDetails} returns this
*/
proto.cloud.BillingDetails.prototype.setBillingAddress = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.BillingDetails} returns this
 */
proto.cloud.BillingDetails.prototype.clearBillingAddress = function() {
  return this.setBillingAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.BillingDetails.prototype.hasBillingAddress = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.BillingAddress.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.BillingAddress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.BillingAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingAddress.toObject = function(includeInstance, msg) {
  var f, obj = {
    city: jspb.Message.getFieldWithDefault(msg, 1, ""),
    country: jspb.Message.getFieldWithDefault(msg, 2, ""),
    addressLine1: jspb.Message.getFieldWithDefault(msg, 3, ""),
    addressLine2: jspb.Message.getFieldWithDefault(msg, 4, ""),
    postalCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
    state: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.BillingAddress}
 */
proto.cloud.BillingAddress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.BillingAddress;
  return proto.cloud.BillingAddress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.BillingAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.BillingAddress}
 */
proto.cloud.BillingAddress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressLine1(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressLine2(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostalCode(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.BillingAddress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.BillingAddress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.BillingAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BillingAddress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddressLine1();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAddressLine2();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPostalCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string city = 1;
 * @return {string}
 */
proto.cloud.BillingAddress.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingAddress} returns this
 */
proto.cloud.BillingAddress.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string country = 2;
 * @return {string}
 */
proto.cloud.BillingAddress.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingAddress} returns this
 */
proto.cloud.BillingAddress.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string address_line1 = 3;
 * @return {string}
 */
proto.cloud.BillingAddress.prototype.getAddressLine1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingAddress} returns this
 */
proto.cloud.BillingAddress.prototype.setAddressLine1 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string address_line2 = 4;
 * @return {string}
 */
proto.cloud.BillingAddress.prototype.getAddressLine2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingAddress} returns this
 */
proto.cloud.BillingAddress.prototype.setAddressLine2 = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string postal_code = 5;
 * @return {string}
 */
proto.cloud.BillingAddress.prototype.getPostalCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingAddress} returns this
 */
proto.cloud.BillingAddress.prototype.setPostalCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string state = 6;
 * @return {string}
 */
proto.cloud.BillingAddress.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BillingAddress} returns this
 */
proto.cloud.BillingAddress.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.Product.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.Product.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.Product} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Product.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    priceMonthly: (f = msg.getPriceMonthly()) && proto.cloud.Price.toObject(includeInstance, f),
    priceYearly: (f = msg.getPriceYearly()) && proto.cloud.Price.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.Product}
 */
proto.cloud.Product.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.Product;
  return proto.cloud.Product.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.Product} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.Product}
 */
proto.cloud.Product.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = new proto.cloud.Price;
      reader.readMessage(value,proto.cloud.Price.deserializeBinaryFromReader);
      msg.setPriceMonthly(value);
      break;
    case 7:
      var value = new proto.cloud.Price;
      reader.readMessage(value,proto.cloud.Price.deserializeBinaryFromReader);
      msg.setPriceYearly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.Product.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.Product.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.Product} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Product.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPriceMonthly();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.cloud.Price.serializeBinaryToWriter
    );
  }
  f = message.getPriceYearly();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.cloud.Price.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.cloud.Product.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Product} returns this
 */
proto.cloud.Product.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.cloud.Product.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Product} returns this
 */
proto.cloud.Product.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.cloud.Product.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Product} returns this
 */
proto.cloud.Product.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Price price_monthly = 6;
 * @return {?proto.cloud.Price}
 */
proto.cloud.Product.prototype.getPriceMonthly = function() {
  return /** @type{?proto.cloud.Price} */ (
    jspb.Message.getWrapperField(this, proto.cloud.Price, 6));
};


/**
 * @param {?proto.cloud.Price|undefined} value
 * @return {!proto.cloud.Product} returns this
*/
proto.cloud.Product.prototype.setPriceMonthly = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.Product} returns this
 */
proto.cloud.Product.prototype.clearPriceMonthly = function() {
  return this.setPriceMonthly(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.Product.prototype.hasPriceMonthly = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Price price_yearly = 7;
 * @return {?proto.cloud.Price}
 */
proto.cloud.Product.prototype.getPriceYearly = function() {
  return /** @type{?proto.cloud.Price} */ (
    jspb.Message.getWrapperField(this, proto.cloud.Price, 7));
};


/**
 * @param {?proto.cloud.Price|undefined} value
 * @return {!proto.cloud.Product} returns this
*/
proto.cloud.Product.prototype.setPriceYearly = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.Product} returns this
 */
proto.cloud.Product.prototype.clearPriceYearly = function() {
  return this.setPriceYearly(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.Product.prototype.hasPriceYearly = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.Price.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.Price.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.Price} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Price.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    productId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    recurring: (f = msg.getRecurring()) && proto.cloud.Recurring.toObject(includeInstance, f),
    type: jspb.Message.getFieldWithDefault(msg, 5, 0),
    unitAmount: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.Price}
 */
proto.cloud.Price.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.Price;
  return proto.cloud.Price.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.Price} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.Price}
 */
proto.cloud.Price.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 4:
      var value = new proto.cloud.Recurring;
      reader.readMessage(value,proto.cloud.Recurring.deserializeBinaryFromReader);
      msg.setRecurring(value);
      break;
    case 5:
      var value = /** @type {!proto.cloud.Price.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUnitAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.Price.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.Price.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.Price} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Price.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRecurring();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.cloud.Recurring.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getUnitAmount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.cloud.Price.Type = {
  UNKNOWN_PRICE_TYPE: 0,
  ONE_TIME: 1,
  RECURRING: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.cloud.Price.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Price} returns this
 */
proto.cloud.Price.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool active = 2;
 * @return {boolean}
 */
proto.cloud.Price.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.Price} returns this
 */
proto.cloud.Price.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string product_id = 3;
 * @return {string}
 */
proto.cloud.Price.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Price} returns this
 */
proto.cloud.Price.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Recurring recurring = 4;
 * @return {?proto.cloud.Recurring}
 */
proto.cloud.Price.prototype.getRecurring = function() {
  return /** @type{?proto.cloud.Recurring} */ (
    jspb.Message.getWrapperField(this, proto.cloud.Recurring, 4));
};


/**
 * @param {?proto.cloud.Recurring|undefined} value
 * @return {!proto.cloud.Price} returns this
*/
proto.cloud.Price.prototype.setRecurring = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.Price} returns this
 */
proto.cloud.Price.prototype.clearRecurring = function() {
  return this.setRecurring(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.Price.prototype.hasRecurring = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Type type = 5;
 * @return {!proto.cloud.Price.Type}
 */
proto.cloud.Price.prototype.getType = function() {
  return /** @type {!proto.cloud.Price.Type} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.cloud.Price.Type} value
 * @return {!proto.cloud.Price} returns this
 */
proto.cloud.Price.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 unit_amount = 6;
 * @return {number}
 */
proto.cloud.Price.prototype.getUnitAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Price} returns this
 */
proto.cloud.Price.prototype.setUnitAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.Recurring.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.Recurring.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.Recurring} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Recurring.toObject = function(includeInstance, msg) {
  var f, obj = {
    aggregateUseage: jspb.Message.getFieldWithDefault(msg, 1, ""),
    interval: jspb.Message.getFieldWithDefault(msg, 2, 0),
    intervalCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.Recurring}
 */
proto.cloud.Recurring.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.Recurring;
  return proto.cloud.Recurring.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.Recurring} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.Recurring}
 */
proto.cloud.Recurring.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAggregateUseage(value);
      break;
    case 2:
      var value = /** @type {!proto.cloud.Recurring.BillInterval} */ (reader.readEnum());
      msg.setInterval(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIntervalCount(value);
      break;
    case 4:
      var value = /** @type {!proto.cloud.Recurring.UsageType} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.Recurring.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.Recurring.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.Recurring} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Recurring.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAggregateUseage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInterval();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getIntervalCount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.cloud.Recurring.BillInterval = {
  UNKNOWN_INTERVAL: 0,
  DAY: 2,
  WEEK: 3,
  MONTH: 4,
  YEAR: 5
};

/**
 * @enum {number}
 */
proto.cloud.Recurring.UsageType = {
  UNKNOWN_TYPE: 0,
  METERED: 1,
  LICENSED: 2
};

/**
 * optional string aggregate_useage = 1;
 * @return {string}
 */
proto.cloud.Recurring.prototype.getAggregateUseage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Recurring} returns this
 */
proto.cloud.Recurring.prototype.setAggregateUseage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional BillInterval interval = 2;
 * @return {!proto.cloud.Recurring.BillInterval}
 */
proto.cloud.Recurring.prototype.getInterval = function() {
  return /** @type {!proto.cloud.Recurring.BillInterval} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.cloud.Recurring.BillInterval} value
 * @return {!proto.cloud.Recurring} returns this
 */
proto.cloud.Recurring.prototype.setInterval = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 interval_count = 3;
 * @return {number}
 */
proto.cloud.Recurring.prototype.getIntervalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Recurring} returns this
 */
proto.cloud.Recurring.prototype.setIntervalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional UsageType type = 4;
 * @return {!proto.cloud.Recurring.UsageType}
 */
proto.cloud.Recurring.prototype.getType = function() {
  return /** @type {!proto.cloud.Recurring.UsageType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.cloud.Recurring.UsageType} value
 * @return {!proto.cloud.Recurring} returns this
 */
proto.cloud.Recurring.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


goog.object.extend(exports, proto.cloud);
